(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9459],{

/***/ 49439:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ EventCardInteractionWrapper_EventCardInteractionWrapper; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/pubsub-js/src/pubsub.js
var pubsub = __webpack_require__(1798);
var pubsub_default = /*#__PURE__*/__webpack_require__.n(pubsub);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(47166);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./hooks/useWindowSize.js
var useWindowSize = __webpack_require__(90698);
// EXTERNAL MODULE: ./components/CommunityContext.tsx + 17 modules
var CommunityContext = __webpack_require__(9973);
// EXTERNAL MODULE: ./utils/rawId.ts
var rawId = __webpack_require__(93593);
// EXTERNAL MODULE: ./schema/globalTypes.ts
var globalTypes = __webpack_require__(5527);
// EXTERNAL MODULE: ./helpers/interactions/index.ts
var interactions = __webpack_require__(56427);
// EXTERNAL MODULE: ./constants/eventNames.ts
var eventNames = __webpack_require__(81340);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(59830);
// EXTERNAL MODULE: ./utils/routerHelpers.ts
var routerHelpers = __webpack_require__(4154);
// EXTERNAL MODULE: ./constants/trackingEvents.ts
var trackingEvents = __webpack_require__(89131);
// EXTERNAL MODULE: ./toga/Card.tsx
var Card = __webpack_require__(23077);
// EXTERNAL MODULE: ./utils/userHelpers.js
var userHelpers = __webpack_require__(73652);
// EXTERNAL MODULE: ./components/Events/components/EventCardInteractionWrapper/EventCardInteractionWrapper.module.scss
var EventCardInteractionWrapper_module = __webpack_require__(26284);
var EventCardInteractionWrapper_module_default = /*#__PURE__*/__webpack_require__.n(EventCardInteractionWrapper_module);
;// CONCATENATED MODULE: ./components/Events/components/EventCardInteractionWrapper/EventCardInteractionWrapper.tsx




















var cx = bind_default().bind((EventCardInteractionWrapper_module_default()));
var EventCardInteractionWrapper = function(param) {
    var children = param.children, eventStatus = param.eventStatus, eventId = param.eventId, dataQA = param.dataQA;
    var router = (0,next_router.useRouter)();
    var ref = (0,CommunityContext/* useCommunityContext */.v1)(), community = ref.community, trackEvent = ref.trackEvent, currentUser = ref.currentUser;
    var eventCardRef = (0,react.useRef)(null);
    var isPastEvent = eventStatus === globalTypes/* EventStatusTypes.EXPIRED */.t.EXPIRED;
    var width = (0,useWindowSize/* useWindowSize */.i)().width;
    var isMobile = width < constants/* SCREEN_LG */.k4;
    var handleOpenEventPanel = function(e, id) {
        e.preventDefault();
        if (isMobile) {
            e.stopPropagation();
            (0,routerHelpers/* goToEvent */.s6)(router, id, community.id);
        } else {
            var _obj;
            trackEvent(trackingEvents/* default.OPEN_LIVE_EVENT_DETAILS_TAB */.ZP.OPEN_LIVE_EVENT_DETAILS_TAB, (_obj = {}, (0,_define_property/* default */.Z)(_obj, trackingEvents/* TrackingProperty.LIVE_EVENT_ID */.Ku.LIVE_EVENT_ID, (0,rawId/* rawId */.b)(id || "")), (0,_define_property/* default */.Z)(_obj, trackingEvents/* TrackingProperty.LIVE_EVENT_ID_ENCODED */.Ku.LIVE_EVENT_ID_ENCODED, id), _obj));
            pubsub_default().publish(eventNames/* eventNames.OPEN_EVENT_PANEL */.S.OPEN_EVENT_PANEL, {
                eventId: eventId,
                lastElementRef: eventCardRef
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: cx("card", {
            "is-past-event": isPastEvent && !(0,userHelpers/* isAdmin */.GJ)(currentUser)
        }),
        "data-qa": dataQA,
        ref: eventCardRef
    }, (0,interactions/* a11yOnClick */.Z)(function(e) {
        var isTargetWithinFooter = e.target.closest('[class*="'.concat(Card/* togaFooterBlockName */.u, '"]'));
        if (!isTargetWithinFooter) {
            handleOpenEventPanel(e, eventId);
        }
    })), {
        children: children
    }));
};
/* harmony default export */ var EventCardInteractionWrapper_EventCardInteractionWrapper = (EventCardInteractionWrapper);

;// CONCATENATED MODULE: ./components/Events/components/EventCardInteractionWrapper/index.ts



/***/ }),

/***/ 30899:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ UpcomingEvents_UpcomingEvents; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(47166);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(37887);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 29 modules
var es = __webpack_require__(1922);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/IconButton-9b57b44f.js
var IconButton_9b57b44f = __webpack_require__(65569);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Button-b37f2f11.js
var Button_b37f2f11 = __webpack_require__(79707);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Icon-343b84c4.js
var Icon_343b84c4 = __webpack_require__(42990);
// EXTERNAL MODULE: ./utils/userHelpers.js
var userHelpers = __webpack_require__(73652);
// EXTERNAL MODULE: ./schema/Event/queries.ts
var queries = __webpack_require__(70564);
// EXTERNAL MODULE: ./utils/toastHelpers.ts
var toastHelpers = __webpack_require__(55049);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(59830);
// EXTERNAL MODULE: ./koba/components/Typography/index.ts + 6 modules
var Typography = __webpack_require__(63579);
// EXTERNAL MODULE: ./components/CommunityContext.tsx + 17 modules
var CommunityContext = __webpack_require__(9973);
// EXTERNAL MODULE: ./components/Events/components/EventCard/EventCard.tsx
var EventCard = __webpack_require__(24159);
// EXTERNAL MODULE: ./hooks/useWindowSize.js
var useWindowSize = __webpack_require__(90698);
// EXTERNAL MODULE: ./utils/routerHelpers.ts
var routerHelpers = __webpack_require__(4154);
// EXTERNAL MODULE: ./schema/globalTypes.ts
var globalTypes = __webpack_require__(5527);
// EXTERNAL MODULE: ./constants/trackingEvents.ts
var trackingEvents = __webpack_require__(89131);
// EXTERNAL MODULE: ./components/VisibilityCloak/VisibilityCloak.tsx
var VisibilityCloak = __webpack_require__(37510);
// EXTERNAL MODULE: ./components/Events/components/EventCardInteractionWrapper/index.ts + 1 modules
var EventCardInteractionWrapper = __webpack_require__(49439);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Row-ef6c768c.js
var Row_ef6c768c = __webpack_require__(93928);
// EXTERNAL MODULE: ./toga/index.ts + 2 modules
var toga = __webpack_require__(5370);
// EXTERNAL MODULE: ./koba/components/Button/index.ts
var Button = __webpack_require__(99438);
// EXTERNAL MODULE: ./hooks/useLocalStorage.ts
var useLocalStorage = __webpack_require__(6482);
// EXTERNAL MODULE: ./components/InfoCard/index.ts + 3 modules
var InfoCard = __webpack_require__(4069);
// EXTERNAL MODULE: ./components/AdminOnlyIndicator/index.tsx
var AdminOnlyIndicator = __webpack_require__(31785);
// EXTERNAL MODULE: ./components/Events/components/EventAdoptionPanel/EventAdoptionPanel.module.scss
var EventAdoptionPanel_module = __webpack_require__(98880);
var EventAdoptionPanel_module_default = /*#__PURE__*/__webpack_require__.n(EventAdoptionPanel_module);
// EXTERNAL MODULE: ./components/Image/index.ts + 1 modules
var Image = __webpack_require__(82513);
// EXTERNAL MODULE: ./components/Events/components/MiniEventPreviewCard/MiniEventPreviewCard.module.scss
var MiniEventPreviewCard_module = __webpack_require__(76131);
var MiniEventPreviewCard_module_default = /*#__PURE__*/__webpack_require__.n(MiniEventPreviewCard_module);
;// CONCATENATED MODULE: ./components/Events/components/MiniEventPreviewCard/MiniEventPreviewCard.tsx







var cx = bind_default().bind((MiniEventPreviewCard_module_default()));
// If we get rid of the text in this preview, we can remove this entire component
var MiniEventPreviewCard = function() {
    var t = (0,es/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: cx("mini-event-preview-card"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                className: cx("mini-event-preview-card__image"),
                height: 590,
                src: constants/* EVENT_ADOPTION_IMAGE */.Q,
                width: 850
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: cx("mini-event-preview-card__content"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: cx("mini-event-preview-card__content__date"),
                        children: t("example-event-date", "January 1, 2:00 PM GMT-7")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: cx("mini-event-preview-card__content__title"),
                        children: t("example-event-title", "Weekly Group Q&A")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var MiniEventPreviewCard_MiniEventPreviewCard = (MiniEventPreviewCard);

;// CONCATENATED MODULE: ./components/Events/components/EventAdoptionPanel/EventAdoptionPanel.tsx















var EventAdoptionPanel_cx = bind_default().bind((EventAdoptionPanel_module_default()));
var EventAdoptionPanel = function(param) {
    var goToCreateEventPage = param.goToCreateEventPage;
    var EVENT_ADOPTION_KEY = "hideEventAdoptionPanel";
    var community = (0,CommunityContext/* useCommunityContext */.v1)().community;
    var isSaved = (0,useLocalStorage/* default */.Z)(EVENT_ADOPTION_KEY).isSaved;
    var t = (0,es/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(isSaved), hideAdoptionPanel = ref[0], setHideAdoptionPanel = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: hideAdoptionPanel ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: EventAdoptionPanel_cx("event-adoption__hint-container"),
            "data-qa": "event-adoption__hint-container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: EventAdoptionPanel_cx("event-adoption__hint-text"),
                    children: t("components-events-eventsAdoptionPanel-events_adoption_hint", "Increase student engagement with live events.")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    className: EventAdoptionPanel_cx("event-adoption__hint-link"),
                    href: constants/* EVENT_LEARN_MORE_LINK */.pj,
                    target: "_blank",
                    children: [
                        t("common-learn_more", "Learn more"),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon_343b84c4.I, {
                            className: EventAdoptionPanel_cx("event-adoption__hint-link-icon"),
                            name: "arrow-up-right",
                            style: {
                                fill: "#5668c7"
                            }
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoCard/* default */.Z, {
            dataQA: "event-adoption__panel",
            localStorageKey: EVENT_ADOPTION_KEY,
            title: t("components-events-eventsAdoptionPanel-events_adoption_header", "Host live events in your Community"),
            isDismissable: true,
            onClose: function() {
                setHideAdoptionPanel(true);
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_ef6c768c.R, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(toga/* Col */.JX, {
                            lgColumns: 8,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: EventAdoptionPanel_cx("mb-2"),
                                    children: t("components-events-eventsAdoptionPanel-events_adoption_subtext", "Create dynamic, live learning experiences that engage your students and keep them coming back - now with invite emails and RSVP functionality.")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: EventAdoptionPanel_cx("mb-1"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                                            appearance: "default",
                                            "aria-label": t("Go to create event form"),
                                            className: EventAdoptionPanel_cx("event-adoption__button-create"),
                                            color: community.primaryColor,
                                            "data-qa": "event-adoption__button-create",
                                            onClick: goToCreateEventPage,
                                            children: t("common-CREATE_EVENT", "CREATE EVENT")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                                            appearance: "ghost",
                                            "aria-label": t("common-learn_more", "Learn more"),
                                            className: EventAdoptionPanel_cx("event-adoption__button-learn-more"),
                                            "data-qa": "event-adoption__button-learn-more",
                                            href: constants/* EVENT_LEARN_MORE_LINK */.pj,
                                            target: "_blank",
                                            children: t("common-LEARN_MORE", "LEARN MORE")
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(toga/* Col */.JX, {
                            lgColumns: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VisibilityCloak/* default */.Z, {
                                hideMD: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniEventPreviewCard_MiniEventPreviewCard, {})
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AdminOnlyIndicator/* default */.Z, {})
            ]
        })
    });
};
/* harmony default export */ var EventAdoptionPanel_EventAdoptionPanel = (EventAdoptionPanel);

;// CONCATENATED MODULE: ./components/Events/components/EventAdoptionPanel/index.ts


// EXTERNAL MODULE: ./components/Events/components/UpcomingEvents/UpcomingEvents.module.scss
var UpcomingEvents_module = __webpack_require__(69372);
var UpcomingEvents_module_default = /*#__PURE__*/__webpack_require__.n(UpcomingEvents_module);
;// CONCATENATED MODULE: ./components/Events/components/UpcomingEvents/UpcomingEvents.tsx























var UpcomingEvents_cx = bind_default().bind((UpcomingEvents_module_default()));
var UpcomingEvents = function(param) {
    var _shouldDisplayHeader = param.shouldDisplayHeader, shouldDisplayHeader = _shouldDisplayHeader === void 0 ? true : _shouldDisplayHeader, _numberOfEvents = param.numberOfEvents, numberOfEvents = _numberOfEvents === void 0 ? constants/* NUMBER_OF_EVENTS_ON_HOME */.rv : _numberOfEvents, setHideComponent = param.setHideComponent;
    var ref, ref1;
    var router = (0,next_router.useRouter)();
    var ref2 = (0,CommunityContext/* useCommunityContext */.v1)(), community = ref2.community, currentUser = ref2.currentUser, trackEvent = ref2.trackEvent;
    var t = (0,es/* useTranslation */.$G)().t;
    var width = (0,useWindowSize/* useWindowSize */.i)().width;
    var isMobile = width < constants/* SCREEN_PHONE */.SO;
    var _query = router.query, eventIdParam = _query.eventId;
    var ref3 = (0,useQuery/* useQuery */.a)(queries/* LIVE_EVENTS_LIST_QUERY */.lq, {
        variables: {
            eventSourceId: community.id,
            eventStatus: globalTypes/* EventStatusTypes.UPCOMING */.t.UPCOMING,
            numberOfEvents: numberOfEvents
        },
        fetchPolicy: "cache-first",
        onError: function() {
            (0,toastHelpers/* genericToastAlert */.d9)();
        }
    }), loading = ref3.loading, data = ref3.data;
    var events = data === null || data === void 0 ? void 0 : (ref = data.site) === null || ref === void 0 ? void 0 : ref.liveEvents;
    var eventsEdges = events === null || events === void 0 ? void 0 : events.edges;
    if (eventIdParam) {
        eventsEdges = eventsEdges === null || eventsEdges === void 0 ? void 0 : eventsEdges.filter(function(edge) {
            var ref;
            return (edge === null || edge === void 0 ? void 0 : (ref = edge.node) === null || ref === void 0 ? void 0 : ref.id) !== eventIdParam;
        }).slice(0, constants/* NUMBER_OF_EVENTS_ON_HOME */.rv);
    }
    var goToCreateEventPage = function() {
        trackEvent(trackingEvents/* default.CLICK_CREATE_LIVE_EVENT */.ZP.CLICK_CREATE_LIVE_EVENT, (0,_define_property/* default */.Z)({}, trackingEvents/* TrackingProperty.COMPONENT */.Ku.COMPONENT, "UpcomingEvents"));
        (0,routerHelpers/* goToNewEvent */.op)(router, community.id);
    };
    var goToEventsPage = function() {
        trackEvent(trackingEvents/* default.CLICK_SEE_ALL_EVENTS */.ZP.CLICK_SEE_ALL_EVENTS);
        (0,routerHelpers/* goToEvents */.MW)(router, community.id);
    };
    (0,react.useEffect)(function() {
        if (setHideComponent) {
            setHideComponent((eventsEdges === null || eventsEdges === void 0 ? void 0 : eventsEdges.length) === 0 || false);
        }
    }, [
        eventsEdges === null || eventsEdges === void 0 ? void 0 : eventsEdges.length
    ]);
    var createEventButton = (0,userHelpers/* canAccess */.WL)([
        constants/* USER_ROLES.SITE_OWNER_SITE_ADMIN */.pR.SITE_OWNER_SITE_ADMIN,
        constants/* USER_ROLES.SITE_ADMIN */.pR.SITE_ADMIN,
        constants/* USER_ROLES.PARTNER */.pR.PARTNER, 
    ], currentUser) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_9b57b44f.I, {
            appearance: "utility",
            "aria-label": t("shared-CREATE_EVENT", "CREATE EVENT"),
            className: UpcomingEvents_cx("create-event__button"),
            "data-qa": "create-event__icon-button",
            name: "plus",
            title: t("shared-CREATE_EVENT", "CREATE EVENT"),
            onClick: goToCreateEventPage
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_b37f2f11.B, {
            appearance: "knockout",
            className: UpcomingEvents_cx("create-event__button"),
            "data-qa": "create-event__button",
            onClick: goToCreateEventPage,
            children: [
                t("shared-CREATE_EVENT", "CREATE EVENT"),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon_343b84c4.I, {
                    name: "plus"
                })
            ]
        })
    });
    var seeAllButton = (events === null || events === void 0 ? void 0 : (ref1 = events.pageInfo) === null || ref1 === void 0 ? void 0 : ref1.hasNextPage) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_b37f2f11.B, {
        appearance: "secondary",
        "data-qa": "see-all__button",
        onClick: goToEventsPage,
        children: t("SEE ALL")
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "data-loading": loading,
        "data-qa": "upcoming-events",
        children: !loading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                shouldDisplayHeader && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: UpcomingEvents_cx("upcoming-events__header"),
                    "data-qa": "upcoming-events-header",
                    children: (!(eventsEdges === null || eventsEdges === void 0 ? void 0 : eventsEdges.length) && (0,userHelpers/* isAdmin */.GJ)(currentUser) || !!(eventsEdges === null || eventsEdges === void 0 ? void 0 : eventsEdges.length)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography.P, {
                                className: UpcomingEvents_cx("upcoming-events__header-title"),
                                children: t("components-events-upcomingEvents-UPCOMING_EVENTS", "UPCOMING EVENTS")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: UpcomingEvents_cx("upcoming-events__header-buttons"),
                                children: [
                                    createEventButton,
                                    !isMobile && seeAllButton
                                ]
                            })
                        ]
                    })
                }),
                (eventsEdges === null || eventsEdges === void 0 ? void 0 : eventsEdges.length) === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(VisibilityCloak/* default */.Z, {
                    admins: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EventAdoptionPanel_EventAdoptionPanel, {
                        goToCreateEventPage: goToCreateEventPage
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: UpcomingEvents_cx("upcoming-events__list"),
                    children: [
                        eventsEdges === null || eventsEdges === void 0 ? void 0 : eventsEdges.map(function(edge) {
                            var node = edge === null || edge === void 0 ? void 0 : edge.node;
                            if (node) {
                                var ref, ref1;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(EventCardInteractionWrapper/* default */.Z, {
                                    dataQA: "upcoming-events__list-card",
                                    eventId: node.id,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EventCard/* default */.Z, {
                                        endTime: node.endTime,
                                        id: node.id,
                                        imageAltText: node.imageAltText,
                                        imageUrl: node.imageUrl,
                                        interestedUserCount: (ref = node.interestedUsers) === null || ref === void 0 ? void 0 : ref.totalCount,
                                        isInterested: node.isInterested || false,
                                        startTime: node.startTime,
                                        timezone: currentUser === null || currentUser === void 0 ? void 0 : (ref1 = currentUser.profile) === null || ref1 === void 0 ? void 0 : ref1.timezone,
                                        title: node.title
                                    })
                                }, node.id);
                            }
                            return null;
                        }),
                        isMobile && seeAllButton
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var UpcomingEvents_UpcomingEvents = (UpcomingEvents);

;// CONCATENATED MODULE: ./components/Events/components/UpcomingEvents/index.ts



/***/ }),

/***/ 72353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ FeatureCloak_FeatureCloak; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./utils/userHelpers.js
var userHelpers = __webpack_require__(73652);
// EXTERNAL MODULE: ./components/CommunityContext.tsx + 17 modules
var CommunityContext = __webpack_require__(9973);
// EXTERNAL MODULE: ./components/SiteFeaturesContext/index.ts + 2 modules
var SiteFeaturesContext = __webpack_require__(40670);
;// CONCATENATED MODULE: ./components/VisibilityHelpers/FeatureCloak/FeatureCloak.tsx





var FeatureCloak = function(param) {
    var admins = param.admins, flags = param.flags, communityEventNotifications = param.communityEventNotifications, communityEvents = param.communityEvents, children = param.children;
    var ref = (0,CommunityContext/* useCommunityContext */.v1)(), currentUser = ref.currentUser, featureFlags = ref.featureFlags;
    var siteFeatures = (0,SiteFeaturesContext/* useSiteFeaturesContext */.Er)().siteFeatures;
    if (flags) {
        var anyFlagsDisabled = flags.some(function(flag) {
            return !featureFlags[flag];
        });
        if (anyFlagsDisabled) return null; // Hide if any of the flags are disabled
    }
    if (typeof communityEventNotifications === "boolean") {
        var ref1;
        // Only show if communityEventNotifications.isEnabled matches the passed boolean
        if ((siteFeatures === null || siteFeatures === void 0 ? void 0 : (ref1 = siteFeatures.communityEventNotifications) === null || ref1 === void 0 ? void 0 : ref1.isEnabled) !== communityEventNotifications) {
            return null;
        }
    }
    if (typeof communityEvents === "boolean") {
        var ref2;
        // Only show if communityEvents.isEnabled matches the passed boolean
        if ((siteFeatures === null || siteFeatures === void 0 ? void 0 : (ref2 = siteFeatures.communityEvents) === null || ref2 === void 0 ? void 0 : ref2.isEnabled) !== communityEvents) {
            return null;
        }
    }
    if (typeof admins === "boolean") {
        if ((0,userHelpers/* isAdmin */.GJ)(currentUser) !== admins) {
            return null;
        }
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
};
/* harmony default export */ var FeatureCloak_FeatureCloak = (FeatureCloak);

;// CONCATENATED MODULE: ./components/VisibilityHelpers/FeatureCloak/index.ts



/***/ }),

/***/ 98880:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"EventAdoptionPanel_sr-only--mobile__oH0Rb","sr-only":"EventAdoptionPanel_sr-only__I1uU5","error-message":"EventAdoptionPanel_error-message__3RIeh","form-inline-edit":"EventAdoptionPanel_form-inline-edit__er0v7","form-group":"EventAdoptionPanel_form-group__fvmwe","form-row":"EventAdoptionPanel_form-row__dG0Lx","form-inline":"EventAdoptionPanel_form-inline__h4iYH","error":"EventAdoptionPanel_error__BDg8A","input-group-append":"EventAdoptionPanel_input-group-append__iwfHi","input-group-currency":"EventAdoptionPanel_input-group-currency__QV06c","form-control":"EventAdoptionPanel_form-control__OxCdr","custom-select":"EventAdoptionPanel_custom-select__2QVMq","is-invalid":"EventAdoptionPanel_is-invalid__0Y4lI","is-valid":"EventAdoptionPanel_is-valid__To7lX","input-group":"EventAdoptionPanel_input-group__32iq3","input-group-text":"EventAdoptionPanel_input-group-text__6j3Gf","input-group-prepend":"EventAdoptionPanel_input-group-prepend__0p4le","valid-feedback":"EventAdoptionPanel_valid-feedback__4VZM_","invalid-feedback":"EventAdoptionPanel_invalid-feedback__Y_qyS","form-text":"EventAdoptionPanel_form-text__JhOMa","label":"EventAdoptionPanel_label__oNNvi","custom-control":"EventAdoptionPanel_custom-control__nQCBO","custom-control-label":"EventAdoptionPanel_custom-control-label__uKcEx","custom-control-label--empty":"EventAdoptionPanel_custom-control-label--empty__UoWFI","custom-control-input":"EventAdoptionPanel_custom-control-input__rQ1bK","mx-3":"EventAdoptionPanel_mx-3__QA6ve","mb-1":"EventAdoptionPanel_mb-1__6s_Bp","mb-2":"EventAdoptionPanel_mb-2__3IAiK","mb-3":"EventAdoptionPanel_mb-3__3SiNe","mb-4":"EventAdoptionPanel_mb-4__Ort5l","mb-5":"EventAdoptionPanel_mb-5__Fczwa","mt-2":"EventAdoptionPanel_mt-2__cTLG3","ml-1":"EventAdoptionPanel_ml-1__x_Wd9","p-2":"EventAdoptionPanel_p-2__setBE","p-3":"EventAdoptionPanel_p-3__CbY8g","border-box":"EventAdoptionPanel_border-box__FoQsq","d-inline-block":"EventAdoptionPanel_d-inline-block__5Zpvb","event-adoption__hint-container":"EventAdoptionPanel_event-adoption__hint-container__a9Eo1","event-adoption__hint-text":"EventAdoptionPanel_event-adoption__hint-text__lomNF","event-adoption__hint-link":"EventAdoptionPanel_event-adoption__hint-link__nuROa","event-adoption__button":"EventAdoptionPanel_event-adoption__button__OI4L1","event-adoption__button-learn-more":"EventAdoptionPanel_event-adoption__button-learn-more__UR2ro","event-adoption__button-close":"EventAdoptionPanel_event-adoption__button-close__XCgbD"};

/***/ }),

/***/ 26284:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"EventCardInteractionWrapper_card__rmYmS","is-past-event":"EventCardInteractionWrapper_is-past-event__cJoA1"};

/***/ }),

/***/ 76131:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"MiniEventPreviewCard_sr-only--mobile__R1Dza","sr-only":"MiniEventPreviewCard_sr-only__daSEV","error-message":"MiniEventPreviewCard_error-message__CHeCf","form-inline-edit":"MiniEventPreviewCard_form-inline-edit__WFrtj","form-group":"MiniEventPreviewCard_form-group__6mdu1","form-row":"MiniEventPreviewCard_form-row__E_lB4","form-inline":"MiniEventPreviewCard_form-inline__kHaHT","error":"MiniEventPreviewCard_error__O6B18","input-group-append":"MiniEventPreviewCard_input-group-append__nydAp","input-group-currency":"MiniEventPreviewCard_input-group-currency__EwW6X","form-control":"MiniEventPreviewCard_form-control__uISRX","custom-select":"MiniEventPreviewCard_custom-select__7_hKC","is-invalid":"MiniEventPreviewCard_is-invalid__LwYes","is-valid":"MiniEventPreviewCard_is-valid__0U2XK","input-group":"MiniEventPreviewCard_input-group__gt7iV","input-group-text":"MiniEventPreviewCard_input-group-text__hn_Ma","input-group-prepend":"MiniEventPreviewCard_input-group-prepend__BxZgZ","valid-feedback":"MiniEventPreviewCard_valid-feedback__KIeiO","invalid-feedback":"MiniEventPreviewCard_invalid-feedback__E8bku","form-text":"MiniEventPreviewCard_form-text__zn0Xj","label":"MiniEventPreviewCard_label__LdZeb","custom-control":"MiniEventPreviewCard_custom-control___16tS","custom-control-label":"MiniEventPreviewCard_custom-control-label__ecRok","custom-control-label--empty":"MiniEventPreviewCard_custom-control-label--empty__0wRep","custom-control-input":"MiniEventPreviewCard_custom-control-input__npFmO","mini-event-preview-card__image":"MiniEventPreviewCard_mini-event-preview-card__image__PR_LB","mini-event-preview-card__content":"MiniEventPreviewCard_mini-event-preview-card__content__6CeAX","mini-event-preview-card__content__date":"MiniEventPreviewCard_mini-event-preview-card__content__date__Hvb5X"};

/***/ }),

/***/ 69372:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"UpcomingEvents_sr-only--mobile__kDFT0","sr-only":"UpcomingEvents_sr-only__e4U0r","error-message":"UpcomingEvents_error-message__VS_Nt","form-inline-edit":"UpcomingEvents_form-inline-edit__TCH7z","form-group":"UpcomingEvents_form-group__nylOQ","form-row":"UpcomingEvents_form-row__ibh4t","form-inline":"UpcomingEvents_form-inline__8muaF","error":"UpcomingEvents_error__MSR5i","input-group-append":"UpcomingEvents_input-group-append__K1T0h","input-group-currency":"UpcomingEvents_input-group-currency__rcwaZ","form-control":"UpcomingEvents_form-control__ii1_U","custom-select":"UpcomingEvents_custom-select__RyDB_","is-invalid":"UpcomingEvents_is-invalid__ywIOk","is-valid":"UpcomingEvents_is-valid__uVPKf","input-group":"UpcomingEvents_input-group__mrxmg","input-group-text":"UpcomingEvents_input-group-text__tscq6","input-group-prepend":"UpcomingEvents_input-group-prepend__j__rt","valid-feedback":"UpcomingEvents_valid-feedback__YvmS7","invalid-feedback":"UpcomingEvents_invalid-feedback__gC3EF","form-text":"UpcomingEvents_form-text__3BgNL","label":"UpcomingEvents_label__My0PG","custom-control":"UpcomingEvents_custom-control__QjVWg","custom-control-label":"UpcomingEvents_custom-control-label__DHZ55","custom-control-label--empty":"UpcomingEvents_custom-control-label--empty__IS_vY","custom-control-input":"UpcomingEvents_custom-control-input__Vm4kL","upcoming-events__list":"UpcomingEvents_upcoming-events__list__uqwwt","upcoming-events__list-card":"UpcomingEvents_upcoming-events__list-card__YkKop","upcoming-events__header":"UpcomingEvents_upcoming-events__header__gk4iq","upcoming-events__header-title":"UpcomingEvents_upcoming-events__header-title__e8LD5","upcoming-events__header-buttons":"UpcomingEvents_upcoming-events__header-buttons__IwtrZ","create-event__button":"UpcomingEvents_create-event__button__2zorI"};

/***/ })

}]);